export interface IPutInQueueEvent {
  queueId: string;
  payload: any;
}

export class PutInQueueService {
  public lastEventTimeout = null;
  public queuePrevEvent: IPutInQueueEvent = null;
  public prevEventStartTime = null;

  public queueProcessing$: Promise<any> = Promise.resolve(null);

  constructor(private logging: boolean) {
  }

  public putInQueue(event: IPutInQueueEvent, caller: (...payload: any[]) => Promise<any>, debounce: number = 500): Promise<any> {
    const clearPrevious = this.queuePrevEvent && event.queueId === this.queuePrevEvent.queueId;
    this.queuePrevEvent = event;
    return new Promise((resolve) => {
      if (this.lastEventTimeout && clearPrevious) {
        clearTimeout(this.lastEventTimeout);
        this.lastEventTimeout = null;
        this._log('CHAIN_WIHT_TIMEOUT', 'prevented previous', event.queueId);
      }

      const started = Date.now();

      this._log('CHAIN_WIHT_TIMEOUT', 'starting executing', event.queueId, new Date().getTime());
      this.lastEventTimeout = setTimeout(() => {
        this.queuePrevEvent = null;
        return this.chainAction(() => caller(...event.payload)
          .catch((err) => this._log('CHAIN_WIHT_TIMEOUT', 'error while executing chunk with event', event.queueId))
          .then((response) => {
            this._log('CHAIN_WIHT_TIMEOUT', 'executed', event.queueId, 'duration', (Date.now() - started) / 1000, 's');
            this.queuePrevEvent = null;
            return resolve(response);
          }), event);
      }, debounce);
    });
  }

  public chainAction(action, context: any) {
    let promise = Promise.resolve(this.queueProcessing$);

    if (this.queueProcessing$ && (this.queueProcessing$ as any).isRejected) {
      this._log('CHAIN', 'Nothing to chain after', context.queueId);
      promise = Promise.resolve(null);
    } else {
      this._log('CHAIN', 'Chaining', context.queueId);
    }

    promise = promise.then(() => {
      if (!this.prevEventStartTime) {
        this.prevEventStartTime = Date.now();
      }

      this._log('CHAIN', 'action started', new Date().getTime(), context.queueId,
        'waiting', (Date.now() - this.prevEventStartTime) / 1000, 's');
      this.prevEventStartTime = Date.now();
      return action();
    });

    return this.queueProcessing$ = promise
      .catch((err) => {
        this._log('CHAIN', 'error while execution action', context.queueId);
        (this.queueProcessing$ as any).isRejected = true;
        this.prevEventStartTime = null;
      });
  }

  protected resetQueue(): void {
    if (this.lastEventTimeout) {
      clearTimeout(this.lastEventTimeout);
    }
  }

  private _log(context: string, ...params: any[]) {
    if (!this.logging) {
      return;
    }

    console.log(context, ...params);
  }
}
